// extracted by mini-css-extract-plugin
export default {"card":"SubCard_card__gFG8I","cardImg":"SubCard_cardImg__3kJYd","center":"SubCard_center__3m6p0"};